import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../model/Entities/User';
import {FormControl, Validators} from '@angular/forms';
import {SnackService} from '../../services/snack.service';
import {ConfigService} from '../../services/config.service';
import {UserRole} from '../../model/Entities/UserRole';

@Component({
  selector: 'user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
  readonly userRoleClass: any = UserRole;

  user: User = new User();
  actualUser: User = this.userService.getLoggedUser();
  editing = false;

  nameFC = new FormControl('', [
    Validators.required,
  ]);

  surnameFC = new FormControl('', [
    Validators.required,
  ]);

  phoneFC = new FormControl();

  emailFC = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  sendingEmailFC = new FormControl('', [
  ]);

  passwordFC = new FormControl('', []);

  constructor(private route: ActivatedRoute,
              private router: Router,
              public userService: UserService,
              private snackService: SnackService,
              public CONFIG: ConfigService,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    const id = +this.route.snapshot.paramMap.get('id');
    if (id !== 0) {
      this.editing = true;
      this.loadUser(id);
    } else {
      this.user.active = true;
      this.passwordFC.setValidators([Validators.required]);
    }
  }

  save(): void {
    if (this.editing) {
      this.userService.update(this.user.id, this.user).subscribe(() => {
        this.router.navigate([`/user/${this.user.id}`]);
        this.snackService.showSuccess(`Účet uživatele ${this.user.name} ${this.user.surname} byl upraven`);
        if (this.userService.getLoggedUser().id === this.user.id) {
          this.userService.updateLoggedUser();
        }
      });
    } else {
      this.userService.save(this.user).subscribe((user: User) => {
        this.router.navigate([`/user/${user.id}`]);
        this.snackService.showSuccess(`Účet uživatele ${user.name} ${user.surname} byl vytvořen`);
      });
    }
  }

  checkValidity(): boolean {
    return this.nameFC.valid
      && this.surnameFC.valid
      && this.phoneFC.valid
      && this.emailFC.valid
      && this.passwordFC.valid
      && this.sendingEmailFC.valid;
  }

  private loadUser(id: Number): void {
    this.userService.get(id).subscribe((user: User) => {
      this.user = user;
      this.cdr.detectChanges();
    });
  }
}



// WEBPACK FOOTER //
// /app/src/UsersModule/UserEditComponent/user-edit.component.ts